// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3f3e4e{display:grid;gap:1em;grid-template-columns:1fr 1fr 1fr;text-align:center;grid-auto-rows:1fr;margin-top:var(--spacer)}._3f3e4e>*{margin-top:0;padding:1em}._3f3e4e svg{font-size:2.5em;margin-bottom:-0.25em}._295b4a{margin-top:var(--medium-spacer);display:grid;gap:1em;grid-template-columns:1fr 1fr 1fr;text-align:center;font-size:.925em}._295b4a button{padding-left:.5em;padding-right:.5em;letter-spacing:.05em}.f8f860{min-height:2em}._5f9db5{color:var(--secondary);margin:5px 0 0 0;font-size:small}", ""]);
// Exports
exports.locals = {
	"features": "_3f3e4e",
	"buttons": "_295b4a",
	"tip": "f8f860",
	"nextPaymentTip": "_5f9db5"
};
module.exports = exports;
